<template>
  <div class="footer_container">
    <div class="footer_container_copyright">
      <a href="http://beian.miit.gov.cn/"
         target="_blank">Copyright © 2022 lasp 沪ICP备18016621号-1</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: "KetiFooter",
    data(){
      return{
        isShow:false
      }
    },
    props:{
      type:{
        type:String,
        default:'pc'
      }
    },
    methods:{
      
    }
  }
</script>

<style scoped lang="less">
.footer_container {
    // background-color: #fff;
    // padding-top:33px;
    .footer_container_copyright {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #8A929E;
        font-size: 16px;
        padding: 24px 0;

        a {
        color: #8A929E;
        margin-bottom: 5px;
        }
        p span {
        margin-right:13px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/layout/footer.vue